import z from 'zod';

export const DateTimeSchema = z.date();
export const NullableDateTimeSchema = z.date().nullable().default(null);

export type Result<T = undefined, E extends string = string> =
	| (T extends undefined // if T is undefined, we can return a result with no data
			? { success: true; message?: E; data?: T }
			: { success: true; message?: E; data: T })
	| {
			success: false;
			message: E;
			data?: T;
	  };

// export const DateTimeSchema = z.preprocess((arg) => {
// 	if (arg === null || arg === undefined) return null;
// 	if (typeof arg === 'string') return new Date(arg);
// 	return arg;
// }, z.date());
